import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Loader } from '../ui/loader';
import UserDistributionsBarChart from '../Charts/UserDistributionsBarChart';
import UserDistributionsMap from '../Charts/UserDistributionsMap';
import { CustomContainer, RequiresLogin } from '.'; // eslint-disable-line import/no-cycle

interface LocationsProps {
  authed: boolean;
  data: any[];
  isFetching: boolean;
  isMobile: boolean;
}

const Locations: React.FC<LocationsProps> = props => {
  const { authed, data, isFetching, isMobile } = props;
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <CustomContainer>
      <Card>
        <CardHeader>
          <CardTitle className={isMobile ? 'text-lg' : 'text-2xl'}>
            熱點
          </CardTitle>
        </CardHeader>
        <CardContent className="relative">
          {isFetching && (
            <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
              <Loader />
            </div>
          )}
          <RequiresLogin dimmed={!authed}>
            {hasData ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {!isMobile && (
                  <div>
                    <UserDistributionsMap
                      data={data}
                      domain={[0, 100]}
                      isMobile={isMobile}
                    />
                  </div>
                )}
                <div>
                  <UserDistributionsBarChart
                    data={data}
                    indexBy="city"
                    isMobile={isMobile}
                    keys={['count']}
                  />
                </div>
              </div>
            ) : (
              <p className="text-gray-500">無資料 (._.)</p>
            )}
          </RequiresLogin>
        </CardContent>
      </Card>
    </CustomContainer>
  );
};

export default Locations;
